<!-- src/views/first-episode.vue -->
<template>
  <div class="open-server">
    <tabHeader
      :tabs="headTabs"
      @tabEvent="tabChange"
      :activeIndex="currentIndex"
    />

    <todayOpen @doOperate="doOperate" v-if="currentIndex == 'todayOpen'" />
    <tomorrowOpen @doOperate="doOperate" v-else />

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>

  </div>
</template>

<script>

import tabHeader from "@/components/TabHeader";
import todayOpen from "./components/TodayOpen.vue";
import tomorrowOpen from "./components/TomorrowOpen.vue";
import gamePlatPopup from "../../components/GamePlatPopup.vue";
import { mapGetters } from "vuex";
export default {
  name: "openServer",
  components: {
    tabHeader,
    gamePlatPopup,
    tomorrowOpen,
    todayOpen
  },
  data() {
    return {
      headTabs: [
        {
          label: "今日开服",
          value: "todayOpen",
        },
        {
          label: "明日开服",
          value: "tomorrowOpen",
        },
      ],
      currentIndex: "todayOpen",
      gameInfo: {},
      btnType: '',
      gamePlatPopupVisible: false
    };
  },
  computed: {
    ...mapGetters(["uuid", "isLogin"]),
  },
  mounted() {},
  methods: {

    tabChange(val) {
      this.currentIndex = val
    },

    doOperate(scope, chennel) {
      if(!this.isLogin) {
        this.$router.push('/login')
        return
      }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id
      }
      this.gamePlatPopupVisible = true;
    }
  },
};
</script>

<style lang="scss">
.open-server {
  
  .game-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    // margin-bottom: 30px;
    padding: 30px 40px;
    border-bottom: 1px solid #e6e6e6;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .game-item-content {
    display: flex;
    align-items: center;

    .game-logo {
      width: 132px;
      height: 132px;
      margin-right: 20px;
    }
    .game-info {
      .game-info-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        h1 {
          max-width: 300px;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 45px;
          margin-right: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          display: block;
          padding: 5px 5px;
          font-weight: 600;
          font-size: 22px;
          color: #ffffff;
          height: 30px;
          background: #ff7a3e;
          border-radius: 4px;
        }
      }
      .game-info-desc {
        width: 280px;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .game-info-gift {
          span {
            padding: 4px 12px;
            background: #f8f8f8;
            border-radius: 4px;
            border: 1px solid #f8f8f8;
            font-weight: 500;
            font-size: 18px;
            color: #a2a2a2;
            margin-right: 8px;
          }
        }
        .star {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            margin-right: 8px;
          }
        }
      }
      .game-tag {
        span {
          padding: 2px 6px;
          // background: #f8f8f8;
          border-radius: 22px;
          border: 0px solid #d2d2d2;
          font-weight: 600;
          font-size: 20px;
          color: #a2a2a2;
          // margin-right: 18px;
        }
        .other-tag {
          color: #ffbe70;
        }
      }
    }
  }

  .game-item-operate {
    span {
      display: block;
      width: 105px;
      height: 50px;
      border-radius: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      line-height: 50px;
      text-align: center;

      &:first-child {
        color: #ffffff;
        background: #ff7a3e;
        margin-bottom: 23px;
      }
      &:last-child {
        border: 2px solid #ff7a3e;
        color: #ff7a3e;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/openServer/index.vue